import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconPositiveSvg } from "./IconPositiveSvg.mjs";
const IconPositive = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconPositiveSvg, ...svgProps }) });
export {
  IconPositive
};
